// All the base paths included in the admin dashboard routes.
// These need to have a leading slash for the client router.
export const adminPaths = [
  '/ai-training',
  '/built-in-designs',
  '/api-tokens',
  '/create-password',
  '/dashboard',
  '/profile',
  '/reset-password',
  '/verify-email-address',
];
